import { Component, EventEmitter, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedModalDataType } from "../modal-service.service";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-shared-modal-success",
  templateUrl: "./modal-success.component.html",
  styleUrls: ["./modal-success.component.css"],
})
export class ModalSuccessComponent {
  data: SharedModalDataType<any> = {
    title: "Missing Title Parameter",
    body: "Default Body",
  };
  @Output() pressedConfirm = new EventEmitter<void>();
  @Output() pressedCancel = new EventEmitter<void>();
  public faCheck = faCheck;
  constructor(public activeModal: NgbActiveModal) {}

  confirm() {
    this.pressedConfirm.emit();
  }
  cancel() {
    this.pressedCancel.emit();
  }
}
